// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"MessengerHeader_HeaderContainer__3TRF_","btnComposeMessage":"MessengerHeader_btnComposeMessage__2wR58"};